export default {"src":"/next-proxy/_next/static/media/amazon-buy.e3c4dcfa.svg","height":150,"width":500,"blurWidth":0,"blurHeight":0};